import React, { useMemo } from 'react';
import Resize from '@ali/arise-h5-utils-img';
import Styles from './index-pc.module.scss';
import SubscribePopup, { POPUP_TYPE } from '../../index-pc';

export default function Banner({
  url = '',
  title = '',
  closeImageUrl = '',
  type,
}: IBanner) {
  const image = useMemo(() => Resize.getFitUrl(url), [url]);
  const closeImage = useMemo(
    () => Resize.getFitUrl(closeImageUrl),
    [closeImageUrl]
  );

  return (
    <div
      className={Styles.banner}
      style={{
        background: `url(${image}) center/cover no-repeat`,
      }}
    >
      <div className={Styles.bannerTitle}>{title}</div>
      <img
        className="auto-evt"
        data-spm={type === POPUP_TYPE.NU_VOUCHER ? 'dNBV_Close' : 'dClose'}
        src={closeImage}
        alt="close"
        onClick={() => {
          SubscribePopup.close();
        }}
      />
    </div>
  );
}

interface IBanner {
  url: string;
  title: string;
  closeImageUrl: string;
  type?: string;
}
